import { GUID, Param } from "app/brightserve/brightserve.module";


export class StreamingObservation {
    ObservationDate: Date;
    Plt: number;
    I: number;
    II: number;
    III: number;
    constructor(init?: Partial<StreamingObservation>) {
        Object.assign(this, init);
        if (init && init.ObservationDate) {
            this.ObservationDate = new Date(init.ObservationDate);
        } else {
            this.ObservationDate = null;
        };
    }
}

export class StreamingObservations {

    StartTimeStamp: Date;
    EndTimeStamp: Date;
    Observations: StreamingObservation[];

    constructor(init?: Partial<StreamingObservations>) {

        Object.assign(this, init);

        if (init && init.StartTimeStamp) {
            this.StartTimeStamp = new Date(init.StartTimeStamp);
        } else {
            this.StartTimeStamp = null;
        };

        if (init && init.EndTimeStamp) {
            this.EndTimeStamp = new Date(init.EndTimeStamp);
        } else {
            this.EndTimeStamp = null;
        };

        if (init && init.Observations) {
            this.Observations = init.Observations.map((res: any) => new StreamingObservation(res));
        } else {
            this.Observations= null;
        };

    };
}



// WEBPACK FOOTER //
// ./src/app/shared/streaming-observations.ts